// extracted by mini-css-extract-plugin
export var button = "PlainTextButton-module--button--8efef";